import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';

/**
 * Compact summary metric for report pages — consistent padding and typography.
 */
const ReportMetricCard = ({
  label,
  value,
  icon,
  accentColor = 'primary.main',
  valueColor,
  caption,
  onClick,
}) => (
  <Card
    elevation={0}
    onClick={onClick}
    sx={{
      height: '100%',
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 1.5,
      cursor: onClick ? 'pointer' : 'default',
      transition: 'border-color 0.15s, box-shadow 0.15s',
      '&:hover': onClick
        ? { borderColor: accentColor, boxShadow: 1 }
        : undefined,
    }}
  >
    <CardContent
      sx={{
        py: 1.25,
        px: 1.5,
        '&:last-child': { pb: 1.25 },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
        {icon ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 34,
              height: 34,
              borderRadius: 1,
              bgcolor: (theme) => theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
              color: accentColor,
              flexShrink: 0,
              '& .MuiSvgIcon-root': { fontSize: 20 },
            }}
          >
            {icon}
          </Box>
        ) : null}
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            variant="caption"
            color="text.secondary"
            display="block"
            lineHeight={1.2}
            noWrap
          >
            {label}
          </Typography>
          <Typography
            variant="subtitle1"
            component="div"
            fontWeight={700}
            color={valueColor || 'text.primary'}
            sx={{
              lineHeight: 1.25,
              fontSize: { xs: '0.9rem', sm: '1rem' },
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {value}
          </Typography>
          {caption ? (
            <Typography
              variant="caption"
              color="text.secondary"
              component="div"
              sx={{ lineHeight: 1.15, mt: 0.25, fontSize: '0.65rem', whiteSpace: 'normal' }}
            >
              {caption}
            </Typography>
          ) : null}
        </Box>
      </Box>
    </CardContent>
  </Card>
);

export default ReportMetricCard;
